import { ComboboxItem } from "@mantine/core"
import { Select } from "@tfg/ui"
import { useMemo, useState } from "react"

import { OrganizationsResponses } from "@tfg/types/endpoints/organizations"

import { useProductSheetGroup } from "~/pages/Brand/CommunicationStudio/contexts/productSheetGroup/useProductSheetGroup"

interface ProductSheetGroupSelectProps {
  productSheetGroups: OrganizationsResponses.OrganizationSettings["displaySettings"]
}

type ProductSheetGroupOption = {
  value: string
  label: string
  original: OrganizationsResponses.OrganizationSettings["displaySettings"][number]
}

export const ProductSheetGroupSelect = ({
  productSheetGroups,
}: ProductSheetGroupSelectProps) => {
  const [opened, setOpened] = useState(false)
  const { selectedProductSheetGroup, setSelectedProductSheetGroup } =
    useProductSheetGroup()

  const options = useMemo(
    () =>
      productSheetGroups.map(
        (group) =>
          ({
            value: group.id,
            label: group.slug,
            original: group,
          }) satisfies ProductSheetGroupOption
      ),
    [productSheetGroups]
  )

  const handleChange = (selectedId: string | null, _option: ComboboxItem) => {
    const matched = options.find((opt) => opt.value === selectedId)

    if (matched) {
      setSelectedProductSheetGroup(matched.original)
    } else {
      // fallback if cleared or nothing selected
      setSelectedProductSheetGroup(productSheetGroups[0] ?? null)
    }
    setOpened(false)
  }

  const validValue =
    selectedProductSheetGroup &&
    options.some((o) => o.value === selectedProductSheetGroup.id)
      ? selectedProductSheetGroup.id
      : productSheetGroups[0]?.id

  return (
    <Select
      data={options}
      value={validValue}
      onChange={handleChange}
      sort={false}
      dropdownOpened={opened}
      onDropdownClose={() => setOpened(false)}
      onDropdownOpen={() => setOpened(true)}
    />
  )
}
